<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <!-- <RadioMenu :menuIndex="menuIndex" :menu="menu" /> -->

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "StaffEscort",
  data() {
    return {
      breadcrumb: [{ name: "人员管理" },{ name: "押运员管理" }],
      menu: [],
      menuIndex: "",
    };
  },
  methods: {
    ...mapMutations(['setState']),
    getCaptains() {
      this.loading = true;
      let url = `fixedpay/getfleet`;
      const params = {
        // userid: this.user.id,
      }
      this.post(
      url, 
      params, 
      ({ fleet }) => {
        this.loading = false;
        this.menu = fleet.map((v, i) => {
          return {
            name: v.nickname,
            path: `/staff/escort/table/${i + 1}`,
            fleet: v.id,
          };
        });
        const { idx } = this.$route.params;
        this.menuIndex = `/staff/escort/table/${idx}`;
        this.setState({
          key: 'fleet',
          value: fleet,
        })
        // console.log(this.menuIndex)
        // console.log(this.menu)
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！',
        });
      });
    },
  },
  mounted() {
    //this.getCaptains();
  },
};
</script>